import { render, staticRenderFns } from "./wghDetail.vue?vue&type=template&id=756247c2&scoped=true"
import script from "./wghDetail.vue?vue&type=script&lang=js"
export * from "./wghDetail.vue?vue&type=script&lang=js"
import style0 from "./wghDetail.vue?vue&type=style&index=0&id=756247c2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "756247c2",
  null
  
)

export default component.exports